'use client'

import * as React from 'react'
import * as Dialog from 'primitives/dialog'
import { lazyComponent } from 'utils/lazy-component'
import { Z_INDEX_MODALS } from 'constants/modals'
import { useFeatureValue } from 'growthbook'

import { usePaymentsCompleteScreenDialog } from '../hooks/use-payments-complete-screen-dialog'
import { clearClientSecretsFromUrl } from '../lib/client-secrets'
import type { PaymentsCompleteScreenDialogContentProps } from './payments-complete-screen-dialog-types'
import { StudioAiExclusiveOfferScreenDialog } from '../../components/studio-ai-exclusive-offer-screen-dialog'

const PaymentsCompleteScreenDialogComponent = lazyComponent(() =>
  import('../complete-screen').then(m => m.PaymentsCompleteScreenDialog),
)

const zIndex = Z_INDEX_MODALS.default

export const PaymentsCompleteScreenDialog = (props: PaymentsCompleteScreenDialogContentProps) => {
  const { getRootProps } = usePaymentsCompleteScreenDialog()
  const isStudioAiExclusiveOfferEnabled = useFeatureValue(
    'GROW-1930-enable-studio-exclusive-offer',
    -1,
  )
  const dialogProps = getRootProps()

  React.useEffect(() => {
    clearClientSecretsFromUrl()
  }, [])

  return (
    <>
      <Dialog.Root {...dialogProps}>
        <Dialog.Portal forceMount>
          <Dialog.Body overlayZIndex={zIndex - 1} zIndex={zIndex}>
            <React.Suspense fallback={null}>
              <PaymentsCompleteScreenDialogComponent.component {...props} />
            </React.Suspense>
          </Dialog.Body>
        </Dialog.Portal>
      </Dialog.Root>
      {isStudioAiExclusiveOfferEnabled !== -1 ? <StudioAiExclusiveOfferScreenDialog /> : null}
    </>
  )
}
